const expiryMonth = (expiry) => {
    return parseInt(expiry.split('/')[0]);
};
export default expiryMonth;
//# sourceMappingURL=expiryMonth.js.map